/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {memo} from 'react';
import {useSelector} from 'react-redux';
import {EditDeviceEditor, EditDeviceEditorProps} from './EditDeviceEditor';
import {
  adminDevicesEditIsEditingSelector,
  adminDevicesViewIsEditingSelector
} from './state-selectors';

export interface EditDeviceDialogProps extends EditDeviceEditorProps {
  enableAdvancedViewDialog?: boolean;
  includeSpreaderChooser?: boolean;
  isMultiSelectSpreader?: boolean;
}

/**
 * Holds dialog functionality for editing a device.
 */
export const EditDeviceDialog = ({
  usePuls = false,
  enableAdvancedViewDialog = false,
  includeGroups = false,
  showSCISettings = false,
  includeAdditionalDeviceFields = false,
  isDeviceNotes = false,
  includeGPSFields = false,
  includeGroupProperties = true,
  includeDatetimeInformation = false,
  includeIdentityInformation = false,
  disableAccountChooser = false,
  showDeviceType = false,
  includeSpreaderChooser = false,
  isMultiSelectSpreader = false
}: EditDeviceDialogProps) => {
  const showEditDevice = useSelector(adminDevicesEditIsEditingSelector);
  const showViewDevice = useSelector(adminDevicesViewIsEditingSelector);
  const isViewDialog = showViewDevice && !enableAdvancedViewDialog;
  return (
    <>
      {(showEditDevice || isViewDialog) && (
        <EditDeviceEditor usePuls={usePuls}
          includeAdditionalDeviceFields={includeAdditionalDeviceFields}
          isDeviceNotes={isDeviceNotes}
          includeDatetimeInformation={includeDatetimeInformation}
          includeIdentityInformation={includeIdentityInformation}
          includeGPSFields={includeGPSFields}
          includeGroups={includeGroups}
          showSCISettings={showSCISettings}
          includeGroupProperties={includeGroupProperties}
          disableAccountChooser={disableAccountChooser}
          includeSpreaderChooser={includeSpreaderChooser}
          isMultiSelectSpreader={isMultiSelectSpreader}
          showDeviceType={showDeviceType}
          isViewDialog={isViewDialog} />
      )}
    </>
  );
};

export default memo(EditDeviceDialog);
